module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-tabs-area"
  }, [_c('div', {
    staticClass: "parent-tabs-area"
  }, [_c('router-link', {
    staticClass: "link-btn icon-collect-link",
    attrs: {
      "to": "collect-list"
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "tabs-content"
  }, _vm._l((_vm.config.parent.arr), function(item, index) {
    return _c('li', {
      staticClass: "tab-item ",
      class: {
        active: index === _vm.config.parent.activeIndex
      }
    }, [_c('a', {
      attrs: {
        "href": item.href
      }
    }, [_vm._v(_vm._s(item.name))])])
  })), _vm._v(" "), _c('a', {
    staticClass: "link-btn icon-portrait",
    attrs: {
      "href": "/#/account-detail"
    }
  })], 1), _vm._v(" "), _c('iscroll-view', {
    ref: "scrollView",
    staticClass: "scroll-view sub-tabs-area",
    attrs: {
      "options": {
        click: true,
        scrollX: true
      },
      "scrollerClass": {
        'scroller': true
      }
    }
  }, _vm._l((_vm.config.sub.arr), function(item, index) {
    return _c('span', {
      staticClass: "tab-item",
      class: {
        active: index === _vm.config.sub.activeIndex, 'has-not-read-msgs': item.notReadNum > 0
      },
      on: {
        "click": function($event) {
          _vm.config.sub.activeIndex = index;
          _vm.selectSubTypeFn(item.en_name)
        }
      }
    }, [_vm._v(_vm._s(item.cn_name))])
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-68a7cf48"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/header-tab.vue
// module id = 176
// module chunks = 1